import type { AppDispatch } from "@/app/store";
import { environment } from "@/shared/config/environment";
import type { ShopConfiguration } from "@/shared/types/shop";
import { layoutDesignApi } from "./api";
import { toLayerConfig } from "./lib/toLayerConfig";
import type { LayerConfig, LayoutSection } from "./types";

// Sempre dati freschi, senza lasciare sottoscrizioni: l'anteprima deve vedere le regole e il builder di adesso.
const FRESH = { subscribe: false, forceRefetch: true } as const;

/** Config del search layer per l'anteprima: scarica regole (e builder, se attivo) e le passa a `toLayerConfig`. */
export async function fetchLayerConfig(
  dispatch: AppDispatch,
  configuration: ShopConfiguration,
): Promise<LayerConfig> {
  // Con `layout` assente rifiuta come il legacy (TypeError sull'accesso), prima di qualsiasi chiamata.
  const builderEnabled = (configuration.layout as LayoutSection).builder?.isActive ?? false;
  const [recommendationRules, builderConfig] = await Promise.all([
    dispatch(layoutDesignApi.endpoints.getRecommendationRules.initiate(configuration.id, FRESH)).unwrap(),
    builderEnabled
      ? dispatch(layoutDesignApi.endpoints.getBuilderConfig.initiate(configuration.id, FRESH)).unwrap()
      : Promise.resolve(null),
  ]);
  return toLayerConfig(configuration, {
    recommendationRules,
    builderConfig,
    baseUrl: environment.directServiceBaseUrl,
  });
}
